export default __webpack_public_path__ + "static/media/tracemgr-hover.fbec40dc.svg";